export class OwnedProjectModel {
    constructor() {
        this.id = "";
        this.name = "";
    }
}
export default class OwnedProject extends OwnedProjectModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
